import React, { useState } from 'react';
import axios from '../api/axios';
import { useNavigate } from 'react-router-dom';
import styles from './Login.module.css'; // reuse existing styles

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await axios.post('/auth/request-password-reset', { email }, { timeout: 15000 });
      setMessage('If your email is registered, you will receive a reset link.');
      setTimeout(() => navigate('/login'), 4000); // optional: redirect after success
    } catch (err: any) {
      // When CORS/network fails, Axios often has no `response`.
      const status = err?.response?.status;
      const serverMessage = err?.response?.data?.message;

      if (!status) {
        setError('Password reset service is unavailable right now. Please try again in a moment.');
      } else {
        setError(serverMessage || 'Failed to request password reset.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <h2 className={styles.loginTitle}>Forgot Password</h2>
      <form onSubmit={handleSubmit} className={styles.loginForm}>
        <div className={styles.formGroup}>
          <input
            type="email"
            placeholder="Your Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.input}
            required
          />
        </div>
        <button type="submit" disabled={loading} className="button">
          {loading ? 'Submitting...' : 'Send Reset Email'}
        </button>
        {error && <p className={styles.errorMessage}>{error}</p>}
        {message && <p className={styles.successMessage}>{message}</p>}
      </form>
    </div>
  );
};

export default ForgotPassword;
